import { IconBrandGoogle, IconCamera, IconMail, IconPlus, IconUser, IconMessage, IconSend, IconTrash, IconUsers, IconCards, IconArrowsSplit, } from "@tabler/icons-react";
import { act, Fragment, use, useContext, useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalTitle } from "../modal";
import { InputForm, SelectInputForm, TextAreaForm } from "../../atoms/input";
import { IconButton, StandardButton, TaskDropdownButton } from "../../atoms/buttons";
import { HorizontalLayout, VerticalLayout, GridLayout, VerticalPageLayout, } from "../layout";
import { deleteAPI, getAPI, postAPI, updateAPI } from "../../api/api";
import { Spinner } from "../../atoms/spinner";
import { ToastContext } from "../../App";
import { format, set } from "date-fns";
import { TextAtom } from "../../atoms/TextAtom";
import { delay, transform } from "framer-motion";
import DepartmentSelectors from "../../molecule/departmentSelector";
import { NotificationComp } from "../notificationComp";
import { icon } from "../../functions/icons";
import { de } from "date-fns/locale";
import { StandardComp } from "../../atoms/standardComp";
import { margin } from "polished";
import { IconAtom } from "../../atoms/iconAtom";
import I from "@editorjs/link";

const EVENT_TYPES = [
  {
    id: "lead_collect",
    icon: <IconUser />,
    title: "Lead verzamelen",
    description: "Informatie over de lead verzamelen",
  },
  {
    id: "first_contact",
    icon: <IconSend />,
    title: "Na eerste contactmoment",
    description: "Nadat het eerste contactmoment is gelegd met de klant.",
  },
  {
    id: "tap_to_learn",
    icon: <IconCards />,
    title: "Tap to learn",
    description: "Nadat een tap-to-learn kaart is geactiveerd",
  },
  {
    id: "demo_planned",
    icon: <IconUsers />,
    title: "Demo ingepland",
    description: "Nadat een demo is ingepland",
  },
];

const AddEventButton = ({ onClick }) => {
  return (
    <button onClick={onClick} className="add-event-button">
      <IconPlus />
      &nbsp;&nbsp; Nieuwe gebeurtenis
    </button>
  );
};

const AddNodeButton = ({ side = "right", onClick }) => {
  const translateX = side === "right" ? "50%" : "-50%";
  return (
    <button
      onClick={onClick}
      style={{
        [side]: "0px",
        transform: `translateY(-50%) translateX(${translateX})`,
      }}
      className="add-node-btn"
    >
      <IconPlus className="hover-rotate" size={20} color="var(--grey-700)" />
    </button>
  );
};

const AddParallelButton = ({ onClick }) => {
  return (
    <button onClick={onClick} className="add-parallel-btn">
      <IconArrowsSplit size={16} color="var(--grey-700)" />
    </button>
  );
};

const DeleteNodeButton = ({ onClick, className }) => {
  return (
    <button onClick={onClick} className={`delete-node-btn ${className}`}>
      <IconTrash size={14} color="var(--error-600)" />
    </button>
  );
};

const EventRow = ({ children }) => {
  return <div className="event-row">{children}</div>;
};

const Node = ({ type, requirements = [], icon, title, description, suffixAddClicked, prefixAddClicked, onAddParallel, onDelete, onClick, action }) => {
  const hasRequirements = requirements.length > 0;
  const [collapsed, setCollapsed] = useState(true);
  const handleClick = () => {
    if (onClick && type === "action") onClick();
  }
  console.log('requirements in node', requirements);
  const [actionCollapsed, setActionCollapsed] = useState(true);
  return (
    <div onClick={handleClick} className={`${hasRequirements ? "flex vertical requirements-container" : ""} ${type === "action" ? "action-node-container" : ""}`}>
      <div className={`template-${type}-block`} onClick={onClick}>
        {prefixAddClicked && (
          <AddNodeButton
            side="left"
            onClick={(e) => {
              e.stopPropagation();
              prefixAddClicked();
            }}
          />
        )}
        <IconButton color="template-block-icon" icon2={icon || ""} />
        <div className="template-block-content">
          <h6>{title}</h6>
          <p>{description}</p>
        </div>
      </div>
      {hasRequirements && (
        <div className="template-block-requirements" onClick={() => setCollapsed(!collapsed)}>
          <HorizontalLayout className="space-between align-center">
            <TextAtom
              className="xsmall-text semi-bold grey-600"
              title="Requirements"
            />
            <IconButton className={collapsed ? "open" : ""} onClick={() => setCollapsed(!collapsed)} icon2={collapsed ? "chevron-down" : "chevron-up"} />
          </HorizontalLayout>
          {!collapsed && (
            <ul className="req-ul">
              {requirements.map((req, index) => (
                <Fragment key={req.id_requirement}>
                  <li className="xsmall-text req-list">
                    {"- "}{req.requirement_title}
                  </li>

                  {index < requirements.length - 1 && (
                    <li className="req-condition">
                      {req.condition === 1 ? "en" : "of"}
                    </li>
                  )}
                </Fragment>
              ))}
            </ul>
          )}

        </div>
      )}
      {type === "action" && action && <ActionStats collapsed={actionCollapsed} setCollapsed={setActionCollapsed} action={action} />}
      {onDelete && (
        <DeleteNodeButton
          className={"phone-delete-node"}
          onClick={(e) => {
            e.stopPropagation();
            onDelete();
          }}
        />
      )}
      {suffixAddClicked && (
        <AddNodeButton
          side="right"
          onClick={(e) => {
            e.stopPropagation();
            suffixAddClicked();
          }}
        />
      )}
      {onAddParallel && (
        <AddParallelButton
          onClick={(e) => {
            e.stopPropagation();
            onAddParallel();
          }}
        />
      )}
    </div>

  );
};
const ActionStats = ({ collapsed, setCollapsed, action }) => {
  const toggles = [
    { key: "wait", label: "Wachten" },
    { key: "continue", label: "Doorgaan" },
    { key: "repeat", label: "Herhalen" },
  ];
  const handleCollapse = (e) => {
    e.stopPropagation();
    setCollapsed(!collapsed);
  }
  return (
    <HorizontalLayout onClick={(e) => handleCollapse(e)} className={`action-stats ${collapsed ? "collapsed" : ""}`} style={{ gap: "1.5rem", alignItems: "center" }} >
      <IconButton onClick={(e) => handleCollapse(e)} icon2={collapsed ? "chevron-down" : "chevron-up"} />
      {!collapsed && <SmallToggleStats
        key="wachttijd"
        title="Wachttijd"
        active={action.delay > 0}
        delay={action.delay}
        hide={true}
      />}
      {!collapsed && toggles.map(t => (
        <SmallToggleStats
          key={t.key}
          title={t.label}
          active={action[t.key] === 1}
        />
      ))}
    </HorizontalLayout>
  );
};


const EventNode = (props) => {
  const handleDelete = async () => {
    const query = "api/tasks/template/step/delete"
    const body = { id_template_step: props.id }
    const res = await deleteAPI(query, body);

    if (res.status === "ok") {
      props.loadTemplate()
    }
  }
  return (
    <Node {...props} requirements={props.requirements} onDelete={handleDelete} type="event" />
  )
};

const ActionNode = (props) => <Node {...props} type="action" />;
const NodeConnector = () => <div className="node-connector"></div>;
const id_parallelGroup = (action) => action && action.actions.length > 1;

const ParallelActionItem = ({ action, eventId, groupIndex, onDeleteAction, editAction, }) => {

  return (
    <div
      className="parallel-action-item"
      onClick={() => editAction({ ...action, eventId, groupIndex })}
    >
      <DeleteNodeButton
        onClick={(e) => {
          e.stopPropagation();
          onDeleteAction(eventId, action.id_action, groupIndex);
        }}
      />
      <IconButton color="template-block-icon" icon2={action.icon || ""} />
      <div className="template-block-content">
        <h6>{action.title}</h6>
        <p>{action.description}</p>
      </div>
    </div>
  );
};

const ParallelGroup = ({ group, eventId, groupIndex, isLast, onAddAction, onAddParallel, onDeleteAction, editAction, }) => {
  return (
    <>
      <NodeConnector />
      <div className="parallel-group-block">
        {isLast && (
          <AddNodeButton
            side="right"
            onClick={(e) => {
              e.stopPropagation();
              onAddAction(eventId, groupIndex + 1);
            }}
          />
        )}
        <div className="parallel-actions-container">
          {group.actions.map((action) => (
            <ParallelActionItem
              key={action.id}
              action={action}
              eventId={eventId}
              groupIndex={groupIndex}
              onDeleteAction={onDeleteAction}
              editAction={editAction}
            />
          ))}
        </div>
        <button
          onClick={() => onAddParallel(eventId, groupIndex, group.id_action_row)}
          className="add-parallel-action-btn"
        >
          <IconArrowsSplit size={16} color="var(--grey-700)" />
        </button>
      </div>
    </>
  );
};


const EmailTemplates = ({ }) => {
  const [email_templates, setEmailTemplates] = useState([{ id: 1, type: "html" }, { id: 2, type: "html" }, { id: 3, type: "html" }, { id: 4, type: "html" }]);
  const [chosenTemplate, setChosenTemplate] = useState(null);
  const loadTemplates = async () => {
    const query = "api/email/templates";
    const res = await getAPI(query);
    if (res.status === "ok") setEmailTemplates(res.data);
  }
  useEffect(() => {
    // loadTemplates();
  }, [])

  return (
    <GridLayout columnsTemplate={chosenTemplate !== null ? "1fr" : "0.5fr 0.5fr"} gap="1rem" style={{ height: "18rem", marginTop: "1rem" }}>
      {(chosenTemplate == null) && email_templates.map((template,index) => (<EmailTemplateNode onClick={() => setChosenTemplate(index)} key={template.id} template={template} />))}
      {chosenTemplate !== null && <ChosenEmailTemplate edit={() => setChosenTemplate(null)} template={email_templates[chosenTemplate]} />}
    </GridLayout>
  )
}

const EmailTemplateNode = ({ template, onClick }) => {

  const templateGen = {
    "html": {
      setup: [{
        line: "80%",
        height: "20%",
        color: "var(--primary-600)"
      }, {
        line: "20%",
        height: "10%",
        color: "var(--primary-500)"
      }, {
        line: "40%",
        height: "10%",
        color: "var(--primary-500)"
      }, {
        line: "45%",
        height: "10%",
        color: "var(--primary-500)"
      }, {
        line: "80%",
        height: "10%",
        color: "var(--primary-600)"
      }]
    }
  }
  return (
    <StandardComp  onClick={onClick}  editClass={"email-node"} style={{ margin: 0, overflow: "hidden", height: "max-content", padding: "0.5rem", display: "flex", flexDirection: "column", backgroundColor: "var(--grey-100)", transition: "all 0.3s ease" }}>
      {templateGen[template.type].setup.map((line, index) => (
        <div key={index} style={{ width: line.line, height: line.height, backgroundColor: line.color, marginBottom: "0.25rem", borderRadius: "4px", paddingBottom: "0.5rem" }}></div>
      ))}
      <VerticalLayout style={{ backgroundColor: "white", padding: "0.5rem", margin: "-0.5rem", marginTop: "0.5rem" }}>
        <TextAtom title={"Snelle hap"} className={"bold-text xsmall-text"} />
        <TextAtom title={template.type.toUpperCase()} className={"xsmall-text"} />
      </VerticalLayout>

    </StandardComp>
  )
}

const LinkedinTemplates = ({ }) => {
  const [reqDropdownOpen, setReqDropdownOpen] = useState(false);
  const [script, setScript] = useState("");
  const [dropdownOptions, setDropdownOptions] = useState([
    { id: 1, content: "Profiel bekijken", selected: false },
    { id: 2, content: "Connectie verzoek sturen", selected: false },
    { id: 3, content: "Bericht sturen", selected: false },
    { id: 4, content: "Automatisch reageren", selected: false }
  ])

  const loadTemplates = async () => {
    const query = `api/linkedin/templates`;
    const load = await getAPI(query);
    if (load.status === "ok") {
      setDropdownOptions(load.data)
    }

  }
  useEffect(() => {
    loadTemplates()

  }, [])
  const handleRequirementChange = async (updatedOptions) => {
    setDropdownOptions(updatedOptions);
    await loadScript(updatedOptions.findIndex(i => i.selected));
  }

  const loadScript = async (index) => {
    const query = `api/linkedin/templates/${dropdownOptions[index].id}/script`;
    const load = await getAPI(query);
    if (load.status === "ok") {
      setScript(load.data.script)

    }

  }
  return (

    <VerticalLayout style={{ gap: "1rem", marginTop: "1rem" }}>
      <TaskDropdownButton title={"Kies linkedin template"} dropdownStyle={{ width: "100%", transform: "unset", marginTop: "0.5rem" }} dropStyle={{ display: "flex", flexDirection: "column" }} isOpen={reqDropdownOpen} onToggle={() => setReqDropdownOpen(prev => !prev)} classContent="task-req" buttonStyle={{ width: "100%" }} setDropdownOptions={handleRequirementChange} dropdown={dropdownOptions} />
      <TextAreaForm
        value={script}
        title="Linkedin template bericht"
        typeInput={(text) => setScript(text)}
      />

    </VerticalLayout>)

}

const AddEventModal = ({ visible, dismiss, loadTemplate }) => {
  const [selectedType, setSelectedType] = useState(null);
  const [requirementCondition, setRequirementCondition] = useState(1);
  const [customTitle, setCustomTitle] = useState("");
  const toastContext = useContext(ToastContext);
  const [customSubtitle, setCustomSubtitle] = useState("");
  const [reqDropdownOpen, setReqDropdownOpen] = useState(false);
  const [requirements, setRequirements] = useState([]);
  const handleAdd = async () => {
    if (!selectedType) return;
    const eventType = EVENT_TYPES.find((e) => e.id === selectedType);
    const query = "api/tasks/template/step/add"
    const body = {
      title: customTitle || eventType.title,
      description: customSubtitle || eventType.description,
      requirement_ids: dropdownOptions.filter(opt => opt.selected).map(opt => opt.id),
      condition: requirementCondition,
    }
    console.log('body', body);
    const res = await postAPI(query, body);

    if (res.status === "ok") {
      loadTemplate()
    }
    resetAndClose();
  };

  const loadRequirements = async () => {
    const query = "api/tasks/template/requirements";
    const res = await getAPI(query);
    if (res.status === "ok") {
      setRequirements(res.data);
    }
  }
  useEffect(() => {
    if (!visible) return
    loadRequirements();
  }, [visible]);

  const resetAndClose = () => {
    setSelectedType(null);
    setCustomTitle("");
    setCustomSubtitle("");
    dismiss();
  };
  const handleSelected = (eventTypeId) => {
    setSelectedType((prev) => (prev === eventTypeId ? null : eventTypeId));
  };
  const visibleEventTypes = selectedType ? EVENT_TYPES.filter((e) => e.id === selectedType) : EVENT_TYPES;
  const isMobile = window.innerWidth <= 768;
  const [dropdownOptions, setDropdownOptions] = useState([]);

  useEffect(() => {
    setDropdownOptions(requirements.map((req) => ({
      id: req.id_requirement,
      content: req.requirement_title,
      selected: false,
    })));
  }, [requirements]);

  const handleRequirementChange = (updatedOptions) => {
    const selectedCount = updatedOptions.filter(o => o.selected).length;

    if (selectedCount > 4) {
      return toastContext.showToast(<>Je kunt maximaal 4 requirements selecteren.</>, "error", 2000);
    }

    setDropdownOptions(updatedOptions);
  };
  return (
    <Modal
      height={null}
      visible={visible}
      hidden={false}
      dismissable={resetAndClose}
      size="small"
    >
      <ModalTitle
        title="Nieuwe gebeurtenis toevoegen"
        hasXmark={true}
        dismissable={resetAndClose}
      />
      <ModalBody>

        <HorizontalLayout className="phone-column" style={{ gap: selectedType && "1rem", alignItems: "flex-start" }}>
          <VerticalLayout>
            <TextAtom className={`${selectedType && !isMobile && "center flex"} small-text semi-bold`} title="Kies een type" />
            <GridLayout columnsTemplate={selectedType ? "1fr" : "1fr 1fr"} gap="0.5rem">
              {visibleEventTypes.map((eventType) => (
                <EventTypeCard
                  key={eventType.id}
                  eventType={eventType}
                  selected={selectedType === eventType.id}
                  onClick={() => handleSelected(eventType.id)}
                />
              ))}
            </GridLayout>
          </VerticalLayout>

          {selectedType && (
            <VerticalLayout>
              <TextAtom className={`${!isMobile && "center"} small-text semi-bold flex`} title="Requirements" />
              <RequirementConditionToggle
                value={requirementCondition}
                onChange={setRequirementCondition}
                disabled={dropdownOptions.filter(opt => opt.selected).length <= 1}
              />
              <TaskDropdownButton isOpen={reqDropdownOpen} onToggle={() => setReqDropdownOpen(prev => !prev)} classContent="task-req" buttonStyle={{ width: "100%" }} setDropdownOptions={handleRequirementChange} multiSelect={true} dropdown={dropdownOptions} />
            </VerticalLayout>
          )}
        </HorizontalLayout>

        {selectedType && (
          <>
            <InputForm
              style={{ marginTop: "1rem" }}
              title="Aangepaste titel (optioneel)"
              placeholder={
                EVENT_TYPES.find((e) => e.id === selectedType)?.title
              }
              value={customTitle}
              typeInput={setCustomTitle}
            />
            <TextAreaForm
              size={isMobile ? "small" : "medium"}
              title="Aangepaste beschrijving (optioneel)"
              placeholder={
                EVENT_TYPES.find((e) => e.id === selectedType)?.description
              }
              value={customSubtitle}
              typeInput={setCustomSubtitle}
            />
          </>
        )}
      </ModalBody>
      <ModalFooter>
        <StandardButton
          className={"phone-modal-button"}
          onClick={resetAndClose}
          title="Annuleren"
        />
        <StandardButton
          className={"phone-modal-button"}
          onClick={handleAdd}
          title="Toevoegen"
          disabled={!selectedType}
        />
      </ModalFooter>
    </Modal>
  );
};

const AddActionModal = ({ visible, dismiss, actionPosition, loadTemplate }) => {
  const [dataToSave, setDataToSave] = useState({
    type: "",
    id_action_type: 0,
    title: "",
    description: "",
    id_template_step: actionPosition.eventId,
    order_in_step: actionPosition.index,
    is_parallel: actionPosition.id_parallel || false,
  });
  const [actionTypes, setActionTypes] = useState([]);
  const [selectedTypeId, setSelectedTypeId] = useState(null);
  const [actionDropdownOpen, setActionDropdownOpen] = useState(false);

  const isMobile = window.innerWidth <= 768;

  const loadActions = async () => {
    const query = "api/tasks/template/actions";
    const res = await getAPI(query);
    if (res.status === "ok") setActionTypes(res.data);
  };

  useEffect(() => {
    if (!visible) return;
    loadActions();
  }, [visible]);
  useEffect(() => {
    if (!selectedTypeId || actionTypes.length === 0) return;

    const selectedType = actionTypes.find(at => at.id_action_type === selectedTypeId);
    if (!selectedType) return;

    setDataToSave(prev => ({
      ...prev,
      type: selectedType.type,
      id_action_type: selectedTypeId,
      title: prev.title || selectedType.type,
    }));
  }, [selectedTypeId, actionTypes]);

  const handleAdd = async () => {
    if (!selectedTypeId) return;

    const body = {
      id_template_step: actionPosition.eventId,
      order_in_step: actionPosition.index,
      id_action_type: selectedTypeId,
      title: dataToSave.title,
      description: dataToSave.description,
      is_parallel: actionPosition.id_parallel || false,
      type: dataToSave.type,
    };
    if (body.is_parallel === true) {
      body.id_action_row = actionPosition.id_action_row
    }
    console.log('body', body);
    const query = "api/tasks/template/action/add";
    const res = await postAPI(query, body);
    if (res.status === "ok") {
      loadTemplate();
      dismiss();
      setDataToSave({
        id_action_type: 0,
        title: "",
        description: "",
        id_template_step: actionPosition.eventId,
        order_in_step: actionPosition.index,
        is_parallel: actionPosition.id_parallel || false,
        type: "",
      });
      setSelectedTypeId(null);
    }
  };
  const dropdownOptions = actionTypes.map(at => ({
    id: at.id_action_type,
    content: at.type + (at.automated ? " (automatisch)" : ""),
    selected: at.id_action_type === selectedTypeId,
  }));
  console.log('actionTypes', dropdownOptions);
  return (
    <Modal hidden={false} height={null} visible={visible} dismissable={dismiss} size="small">
      <ModalTitle title="Nieuwe actie toevoegen" hasXmark={true} dismissable={dismiss} />
      <ModalBody>

        {!selectedTypeId && <TaskDropdownButton
          dropdownStyle={{ width: "100%" }}
          dropStyle={{ display: 'flex' }}
          buttonStyle={{ width: "100%" }}
          dropdown={dropdownOptions}
          title="Kies een actietype"
          selectedId={selectedTypeId}
          isOpen={actionDropdownOpen}
          onToggle={() => setActionDropdownOpen(prev => !prev)}
          onChange={(selected) => setSelectedTypeId(selected[0]?.id)}
        />}
        {selectedTypeId && (
          <ActionModalPages type={selectedTypeId}    dataToSave={dataToSave} setDataToSave={setDataToSave} actionTypes={actionTypes} selectedTypeId={selectedTypeId} isMobile={isMobile} />
        )}



      </ModalBody>
      <ModalFooter style={{ backgroundColor: "var(--grey-50)", paddingTop: "0.75rem", paddingBottom: "0.75rem", paddingRight: "0.75rem", paddingLeft: "0.75rem", justifyContent: "space-between" }}>
        <StandardButton className="phone-modal-button" onClick={dismiss} title="Annuleren" />
        <StandardButton
          className="phone-modal-button"
          onClick={handleAdd}
          title="Toevoegen"
          disabled={!selectedTypeId}
        />
      </ModalFooter>
    </Modal>
  );
};

const ActionSubMenu = ({ setCurrentPage }) => {
  const subMenuOptions = [
    { id: 0, content: "Omschrijving" },
    { id: 1, content: "Tijdsinstellingen" },
    { id: 2, content: "Templates" },
  ]
 const isMobile = window.innerWidth <= 768;
  const [selectedSubMenu, setSelectedSubMenu] = useState(0);
  return (
    <HorizontalLayout style={{ marginLeft:isMobile?"-0.25rem": "-1rem", marginTop: "0rem", gap: "1rem", width: isMobile ?"calc(100% + 0.5rem)" : "calc(100% + 2rem)", justifyContent: "space-evenly", borderWidth: 0, borderBottomWidth: "1px", borderTopWidth: "1px", borderStyle: "solid", borderColor: "var(--border-color)" }}>
      {subMenuOptions.map(option => (
        <HorizontalLayout style={{ width: "100%", padding: "0.5rem", borderBottomWidth: "2px", cursor: "pointer", borderBottomStyle: "solid", borderColor: selectedSubMenu === option.id ? "var(--primary-500)" : "transparent", alignItems: 'center', justifyContent: "center", backgroundColor: selectedSubMenu === option.id ? "var(--primary-50)" : "transparent" }} key={option.id} onClick={() => { setSelectedSubMenu(option.id); setCurrentPage(option.id + 1); }} className={`action-submenu-btn ${selectedSubMenu === option.id ? "selected" : ""}`}>
          <TextAtom style={{ fontSize: "0.85rem", fontWeight: selectedSubMenu === option.id ? "bold" : "normal", color: selectedSubMenu === option.id && "var(--primary-600)" }} title={option.content}></TextAtom>
        </HorizontalLayout>
      ))}
    </HorizontalLayout>
  )
}
const ActionModalPages = ({ type,dataToSave, setDataToSave, actionTypes, selectedTypeId, isMobile }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const topText = [{ title: "Omschrijving aanpassen", description: "Pas de omschrijving van deze actie aan. Je kunt hier de titel en omschrijving aanpassen. Zonder titel wordt de standard actie titel opgeslagen" },{ title: "Tijdsinstellingen", description: "Stel in of en hoe lang er gewacht moet worden voordat deze actie uitgevoerd wordt. Je kunt hier ook instellen of de actie herhaald moet worden." }, { title: "Templates", description: "Kies een template voor deze actie. De inhoud van de template wordt automatisch toegevoegd aan de beschrijving van de actie, maar je kunt dit later nog aanpassen." }]
  return (
    <VerticalLayout style={{ gap: "1rem" }}>
      <ActionSubMenu setCurrentPage={setCurrentPage} />
      <TopMenuText
        title={topText[currentPage - 1].title}
        description={topText[currentPage - 1].description}
      />
      {currentPage == 1 && <TitleDescriptionPage dataToSave={dataToSave} setDataToSave={setDataToSave} actionTypes={actionTypes} selectedTypeId={selectedTypeId} isMobile={isMobile} />}
      {currentPage == 2 && <TimeSettings dataToSave={dataToSave} setDataToSave={setDataToSave} actionTypes={actionTypes} selectedTypeId={selectedTypeId} isMobile={isMobile} />}
      {currentPage == 3 && <ActionTypeFactory type={type} dataToSave={dataToSave} setDataToSave={setDataToSave} actionTypes={actionTypes} selectedTypeId={selectedTypeId} isMobile={isMobile} />}
    </VerticalLayout>


  )


}

const TopMenuText = ({ title, description }) => {
  return (
    <VerticalLayout style={{ gap: "0.25rem" }}>
      <TextAtom title={title} className={"bold-text small-text"} />
      <TextAtom title={description} className={"xsmall-text grey-600"} />
    </VerticalLayout>
  )
}
const TimeSettings = ({ dataToSave, setDataToSave, actionTypes, selectedTypeId, isMobile }) => {
    const toggles = [
    { key: "repeat", label: "Herhalen", icon: "auto-play", description: "Deze actie herhalen nadat deze is uitgevoerd. De wachttijd tussen de herhalingen is gelijk aan de wachttijd die je hier instelt." },
    { key: "wait", label: "Wachten", icon: "wait" ,description: "Wacht een bepaalde tijd voordat deze actie wordt uitgevoerd. De wachttijd is gelijk aan het aantal dagen dat je hier instelt."},
    { key: "continue", label: "Doorgaan", icon: "continue" ,description: "Doorgaan met de volgende actie als deze actie niet binnen de ingestelde wachttijd is uitgevoerd. De wachttijd is gelijk aan het aantal dagen dat je hier instelt."},
  ];
  const toggleNotification = (key) => {    setDataToSave(prev => {
      const updatedValue = prev[key] === 1 ? 0 : 1;
      return { ...prev, [key]: updatedValue };
    });
  }
  return (
    <VerticalLayout style={{ gap: "1rem" }}>
      <InputForm title={"Wachttijd (dagen)"} value={dataToSave.delay} typeInput={(v) => setDataToSave(prev => ({ ...prev, delay: v }))} />
        {toggles.map(toggle => (
          <SmallToggleTitle
            key={toggle.key}
            title={toggle.label}
            description={toggle.description}
            toggleContextIcon={toggle.icon}
            active={dataToSave[toggle.key] === 1}
            onClick={() => toggleNotification(toggle.key)}
          />
        ))}
    </VerticalLayout>)
}


const ChosenEmailTemplate = ({ template,edit }) => {
  return (

    <StandardComp editClass={"email-node"} style={{ margin: 0, overflow: "hidden", height: "max-content", padding: "0.5rem", display: "flex", flexDirection: "column", cursor:"unset", transition:"unset", borderColor:"var(--grey-100)" ,transform:"unset"}}>
      <HorizontalLayout>
      <VerticalLayout style={{padding:"0.5rem"}} >
        <HorizontalLayout><IconAtom icon2={"check"} iconSize={30} color={"var(--primary-600)"} /><TextAtom style={{color:"var(--primary-600)", fontWeight:"bold"}} title={'ACTIEF TEMPLATE'}/></HorizontalLayout>
        <TextAtom title={"Gekozen template"} className={"bold-text"} />
        <TextAtom title={"Dit template word automatisch gebruikt wanneer de taak wordt uitgevoerd."} className={"xsmall-text"} />
        <HorizontalLayout><StandardButton onClick={edit} title="Wijzig template" className={"modal-button"} style={{ margin:0,marginTop: "0.5rem", width:"100%", justifyContent:"center", fontWeight:"bold" }} /> </HorizontalLayout>

      </VerticalLayout>
  
     <StandardComp editClass={"email-node"} style={{ margin: 0, width:"33%",overflow: "hidden", height: "max-content", padding: "0.5rem", display: "flex", flexDirection: "column", backgroundColor: "var(--grey-100)", transition: "all 0.3s ease" }}>
      <div style={{ width: "80%", height: "20%", backgroundColor: "var(--primary-600)", marginBottom: "0.25rem", borderRadius: "4px", paddingBottom: "0.5rem" }}></div>
      <div style={{ width: "20%", height: "10%", backgroundColor: "var(--primary-500)", marginBottom: "0.25rem", borderRadius: "4px", paddingBottom: "0.4rem" }}></div>
      <div style={{ width: "40%", height: "10%", backgroundColor: "var(--primary-500)", marginBottom: "0.25rem", borderRadius: "4px", paddingBottom: "0.4rem" }}></div>
      <div style={{ width: "45%", height: "10%", backgroundColor: "var(--primary-500)", marginBottom: "0.25rem", borderRadius: "4px", paddingBottom: "0.4rem" }}></div>
      <div style={{ width: "80%", height: "10%", backgroundColor: "var(--primary-600)", marginBottom: "0.25rem", borderRadius: "4px", paddingBottom: "0.5rem" }}></div>
      <VerticalLayout style={{ backgroundColor: "white", padding: "0.5rem", margin: "-0.5rem", marginTop: "0.5rem" }}>
        <TextAtom title={"Snelle hap"} className={"bold-text xsmall-text"} />
        <TextAtom title={template.type.toUpperCase()} className={"xsmall-text"} />
      </VerticalLayout>
      </StandardComp>
          </HorizontalLayout>
    </StandardComp>
  )
}

const TitleDescriptionPage = ({ dataToSave, setDataToSave, actionTypes, selectedTypeId, isMobile }) => {

  return (


    <>
      <InputForm
        style={{ marginTop: "1rem" }}
        title="Titel (optioneel)"
        placeholder={"Geen title dan standaard: " + actionTypes.find(at => at.id_action_type === selectedTypeId).type}
        value={dataToSave.title}
        typeInput={(value) => setDataToSave(prev => ({ ...prev, title: value }))}
      />
      <TextAreaForm
        size={isMobile ? "small" : "medium"}
        title="Beschrijving (optioneel)"
        placeholder={"Beschrijf wat " + actionTypes.find(at => at.id_action_type === selectedTypeId).type + " inhoudt"}
        value={dataToSave.description}
        typeInput={(value) => setDataToSave(prev => ({ ...prev, description: value }))}
      />

    </>
  )


}

const ActionTypeFactory = ({ type }) => {
  switch (type) {
    case 2:
      return <EmailTemplates />
    case 9:
      return <LinkedinTemplates />
    default:
      return null;
  }
}

const EventTypeCard = ({ eventType, selected, onClick }) => {
  return (
    <div
      onClick={onClick}
      className={`type-card ${selected ? "selected" : ""}`}
      style={{
        padding: "0.75rem",
        border: `2px solid ${selected ? "var(--primary-500)" : "var(--border-color)"
          }`,
        borderRadius: "8px",
        cursor: "pointer",
        backgroundColor: selected ? "var(--primary-50)" : "transparent",
        transition: "all 0.2s ease",
      }}
    >
      <HorizontalLayout
        className="phone-column"
        style={{ gap: "0.5rem", alignItems: "center" }}
      >
        <div
          style={{ color: selected ? "var(--primary-500)" : "var(--grey-600)" }}
        >
          {eventType.icon}
        </div>
        <VerticalLayout style={{ gap: "0.125rem" }}>
          <p className="small-text semi-bold phone-text-wrap-node-one">
            {eventType.title}
          </p>
          <p className="xsmall-text grey-600 phone-text-wrap-node">
            {eventType.description}
          </p>
        </VerticalLayout>
      </HorizontalLayout>
    </div>
  );
};
const WorkflowRow = (({ event, onAddAction, onAddParallel, onDeleteAction, loadTemplate, editAction, editEvent }) => {
  console.log('event in row', event);
  return (
    <EventRow>
      <EventNode
        id={event.id_template_step}
        icon={event.icon}
        title={event.title}
        requirements={event.requirements}
        description={event.description}
        loadTemplate={loadTemplate}
        suffixAddClicked={() => onAddAction(event.id_template_step)}
        onClick={() => editEvent(event)}
      />
      {event.action_rows.map((action, index) =>
        renderActionItem({
          action,
          index,
          isLast: index === event.action_rows.length - 1,
          eventId: event.id_template_step,
          onAddAction,
          onAddParallel,
          onDeleteAction,
          editAction,
        })
      )}
    </EventRow>
  );
});

const renderActionItem = ({ action, index, isLast, eventId, onAddAction, onAddParallel, onDeleteAction, editAction, }) => {
  if (id_parallelGroup(action)) {
    return (
      <ParallelGroup
        key={action.id_action_row ?? index}
        group={action}
        eventId={eventId}
        groupIndex={index}
        isLast={isLast}
        onAddAction={onAddAction}
        onAddParallel={onAddParallel}
        onDeleteAction={onDeleteAction}
        editAction={editAction}
      />
    );
  }

  return (
    <ActionWithConnector
      key={action.id_action_row ?? index}
      action={action.actions ? action.actions[0] : action}
      eventId={eventId}
      index={index}
      isLast={isLast}
      group={action}
      onAddAction={onAddAction}
      onAddParallel={onAddParallel}
      onDeleteAction={onDeleteAction}
      editAction={editAction}
    />
  );
};


const ActionWithConnector = ({ group, action, eventId, index, isLast, onAddAction, onAddParallel, onDeleteAction, editAction, }) => {
  return (
    <>
      <NodeConnector />
      <ActionNode
        icon={action.icon || ""}
        title={action.title || "Geen titel"}
        description={action.description}
        suffixAddClicked={
          isLast ? () => onAddAction(eventId, index + 1) : undefined
        }
        action={action}
        onAddParallel={() => onAddParallel(eventId, index, group.id_action_row)}
        onDelete={() => onDeleteAction(eventId, action.id_action)}
        onClick={() => editAction({ ...action, eventId })}
      />
    </>
  );
};

export const TemplatePage = () => {
  const [template, setTemplate] = useState({ steps: [] });
  //   const [templates, setTemplates] = useState([]);
  const [showAddEventModal, setShowAddEventModal] = useState(false);
  const [showAddActionModal, setShowAddActionModal] = useState(false);
  const [showEditActionModal, setShowEditActionModal] = useState(false);
  const [showEditEventModal, setShowEditEventModal] = useState(false);
  const [actionPosition, setActionPosition] = useState({
    eventId: null,
    index: 0,
    id_parallel: false,
    id_action_row: null,
  });
  const [selectedNode, setSelectedNode] = useState({});
  const [loading, setLoading] = useState(false);
  const handleEditAction = (node) => {
    setSelectedNode(node);
    setShowEditActionModal(true);
  };
  const handleAddAction = (eventId, index) => {
    setShowAddActionModal(true);
    setActionPosition({ eventId, index: index ?? 0, id_parallel: false });
  }
  const handleAddParallel = (eventId, index, id_action_row) => {
    setShowAddActionModal(true);
    setActionPosition({ eventId, index: index ?? 0, id_parallel: true, id_action_row: id_action_row });
  };
  const handleEditEvent = (event) => {
    setSelectedNode(event);
    setShowEditEventModal(true);
  };
  const handleDeleteAction = async (eventId, actionId) => {
    const query = "api/tasks/template/action/delete"
    const body = { id_template_step: eventId, id_action: actionId }
    const res = await deleteAPI(query, body);

    if (res.status === "ok") {
      loadTemplate()
    }
  }
  // const loadAllTemplates = async () => {
  //     const query = `api/tasks/template`
  //     const res = await getAPI(query);
  //     .status === "ok"){
  //         setTemplates(res.data);
  //     }
  // }
  const loadTemplate = async () => {
    if (!template) return;
    setLoading(true);
    const query = `api/tasks/template`;
    const res = await getAPI(query);
    console.log('res', res);
    if (res.status === "ok") {
      setTemplate(res.data);
    }
    setLoading(false);
  };
  useEffect(() => {
    // loadAllTemplates()
    loadTemplate();
  }, []);
  if (loading) {
    return (
      <VerticalPageLayout className={"center"}>
        <Spinner />
      </VerticalPageLayout>
    );
  }

  return (
    <div className="flowchart-editor-container">
      <div className="flowchart-background">
        {template.steps &&
          template.steps.map((event) => (
            <WorkflowRow
              key={event.id_template_step}
              event={event}
              loadTemplate={() => loadTemplate()}
              editAction={handleEditAction}
              editEvent={handleEditEvent}
              onAddAction={handleAddAction}
              onDeleteAction={handleDeleteAction}
              onAddParallel={handleAddParallel}
            />
          ))}
        <AddEventButton onClick={() => setShowAddEventModal(true)} />
      </div>
      <AddEventModal
        visible={showAddEventModal}
        dismiss={() => setShowAddEventModal(false)}
        loadTemplate={() => loadTemplate()}
      />

      <AddActionModal
        visible={showAddActionModal}
        dismiss={() => setShowAddActionModal(false)}
        actionPosition={actionPosition}
        loadTemplate={() => loadTemplate()}
      />
      <EditEventModal
        visible={showEditEventModal}
        dismiss={() => setShowEditEventModal(false)}
        data={selectedNode}
        loadTemplate={() => loadTemplate()}
      />
      <EditActionModal
        visible={showEditActionModal}
        dismiss={() => { setShowEditActionModal(false); setSelectedNode(null); }}
        data={selectedNode}
        loadTemplate={() => loadTemplate()}
      />
    </div>
  );
};

const EditEventModal = ({ visible, dismiss, data = {}, loadTemplate }) => {
  const toastContext = useContext(ToastContext);
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [requirementCondition, setRequirementCondition] = useState(1);
  const [editReqDropdownOpen, setEditReqDropdownOpen] = useState(false);
  const [dataToSave, setDataToSave] = useState({
    id_template_step: "",
    title: "",
    description: "",
  });
  useEffect(() => {
    if (!visible) return;
    loadRequirements()
    setDataToSave({
      id_template_step: data.id_template_step,
      title: data.title || "",
      description: data.description || "",
    });
  }, [visible, data]);
  const handleDelete = async () => {
    const query = "api/tasks/template/step/delete"
    const body = { id_template_step: data.id_template_step }
    const res = await deleteAPI(query, body);

    if (res.status === "ok") {
      dismiss();
      loadTemplate()
    }
  }
  const handleSave = async () => {
    if (!dataToSave.title.trim() || !dataToSave.description.trim()) return toastContext.showToast(<>De titel en beschrijving mogen niet leeg zijn.</>, "error", 2000);
    const query = "api/tasks/template/step/update"
    const body = {
      id_template_step: dataToSave.id_template_step,
      title: dataToSave.title,
      description: dataToSave.description,
      requirement_ids: dropdownOptions.filter(opt => opt.selected).map(opt => opt.id),
      condition: requirementCondition,
    }
    console.log('body', body);
    const res = await updateAPI(query, body);
    if (res.status === "ok") {
      dismiss();
      loadTemplate()
    }
  };
  const loadRequirements = async () => {
    const query = "api/tasks/template/requirements"
    const res = await getAPI(query);
    console.log('reqs', res);
    if (res.status === "ok") {
      setDropdownOptions(res.data.map(req => ({
        id: req.id_requirement,
        content: req.requirement_title,
        selected: data.requirements?.map(r => r.id_requirement).includes(req.id_requirement) || false,
      })));
    }
  }
  const handleRequirementChange = (updatedOptions) => {
    const selectedCount = updatedOptions.filter(o => o.selected).length;
    if (selectedCount > 4) {
      return toastContext.showToast(<>Je kunt maximaal 4 requirements selecteren.</>, "error", 2000);
    }

    setDropdownOptions(updatedOptions);
  };
  return (
    <Modal height={null} hidden={false} visible={visible} dismissable={dismiss} size="small">
      <ModalTitle
        title={"Step bewerken"}
        hasXmark={true}
        dismissable={dismiss}
      />
      <ModalBody>
        <InputForm title="Titel" value={dataToSave.title || ""} typeInput={(v) => setDataToSave(prev => ({ ...prev, title: v }))} />
        <TextAreaForm
          title="Beschrijving"
          value={dataToSave.description || ""}
          typeInput={(v) => setDataToSave(prev => ({ ...prev, description: v }))}
        />
        <RequirementConditionToggle
          value={requirementCondition}
          onChange={setRequirementCondition}
          disabled={dropdownOptions.filter(opt => opt.selected).length <= 1}
        />
        <TaskDropdownButton isOpen={editReqDropdownOpen} onToggle={() => setEditReqDropdownOpen(prev => !prev)} classContent="task-req" setDropdownOptions={handleRequirementChange} title={"Requirements"} buttonStyle={{ width: "100%" }} multiSelect={true} dropdown={dropdownOptions} />
      </ModalBody>
      <ModalFooter>
        <IconButton
          onClick={handleDelete}
          icon2={"trash"}
          style={{ marginRight: "auto", color: "var(--error-600)" }}
        />
        <StandardButton
          backgroundColor="primary-200"
          textColor="primary-700"
          onClick={dismiss}
          title="Annuleren"
        />
        <StandardButton onClick={handleSave} title="Opslaan" />
      </ModalFooter>
    </Modal>
  );
};


const EditActionModal = ({ visible, dismiss, data = {}, loadTemplate }) => {
  const [dataToSave, setDataToSave] = useState({
    id_action_type: "",
    id_action: "",
    title: "",
    description: "",
    type: "",
    delay: 0,
    repeat: 0,
    wait: 0,
    continue: 0,
  });
  useEffect(() => {
    if (!visible) return;
    setDataToSave({
      id_action: data.id_action,
      id_action_type: data.id_action_type || "",
      title: data.title || "",
      description: data.description || "",
      type: data.type || "",
      delay: data.delay || 0,
      repeat: data.repeat || 0,
      wait: data.wait || 0,
      continue: data.continue || 0,
    });
  }, [visible, data]);
  const handleDeleteAction = async () => {
    const query = "api/tasks/template/action/delete"
    const body = { id_template_step: dataToSave.id_template_step, id_action: dataToSave.id_action }
    const res = await deleteAPI(query, body);
    if (res.status === "ok") {
      dismiss();
      loadTemplate()
    }
  }
  const handleSave = async () => {
    const query = "api/tasks/template/action/update"
    const body = {
      id_action: dataToSave.id_action,
      title: dataToSave.title,
      description: dataToSave.description,
      type: dataToSave.type,
      id_action_type: dataToSave.id_action_type,
      delay: dataToSave.delay || 0,
      repeat: dataToSave.repeat || 0,
      wait: dataToSave.wait || 0,
      continue: dataToSave.continue || 0,
    }
    console.log('data', body);
    const res = await updateAPI(query, body);
    if (res.status === "ok") {
      dismiss();
      loadTemplate()
    }
  }
  const toggleNotification = (key) => {
    setDataToSave(prev => ({ ...prev, [key]: prev[key] === 1 ? 0 : 1 }));
  };
  const toggles = [
    { key: "repeat", label: "Herhalen" },
    { key: "wait", label: "Wachten" },
    { key: "continue", label: "Doorgaan" },
  ];

  return (
    <Modal height={null} hidden={false} visible={visible} dismissable={dismiss} size="small">
      <ModalTitle
        title={"Actie bewerken"}
        hasXmark={true}
        dismissable={dismiss}
      />
      <ModalBody>
        <InputForm title="Titel" value={dataToSave.title || ""} typeInput={(v) => setDataToSave(prev => ({ ...prev, title: v }))} />
        <TextAreaForm
          title="Beschrijving"
          value={dataToSave.description || ""}
          typeInput={(v) => setDataToSave(prev => ({ ...prev, description: v }))}
        />
        <InputForm title={"Wachttijd (dagen)"} value={dataToSave.delay} typeInput={(v) => setDataToSave(prev => ({ ...prev, delay: v }))} />
        {toggles.map(toggle => (
          <SmallToggleTitle
            key={toggle.key}
            title={toggle.label}
            active={dataToSave[toggle.key] === 1}
            onClick={() => toggleNotification(toggle.key)}
          />
        ))}
      </ModalBody>
      <ModalFooter>
        <IconButton
          onClick={handleDeleteAction}
          icon2={"trash"}
          style={{ marginRight: "auto", color: "var(--error-600)" }}
        />
        <StandardButton
          backgroundColor="primary-200"
          textColor="primary-700"
          onClick={dismiss}
          title="Annuleren"
        />
        <StandardButton onClick={handleSave} title="Opslaan" />
      </ModalFooter>
    </Modal>
  );
};

const SmallToggleTitle = ({ title, description, active, onClick, toggleContextIcon }) => {
  return (
    <div onClick={onClick} className="horizontal space-between">
    <HorizontalLayout style={{ gap: "0.5rem", alignItems: "center" }}>
      <IconAtom icon2={toggleContextIcon} />
      <VerticalLayout style={{ gap: "0.125rem" }}>
      <p className="small-text-dark semi-bold">{title}</p>
      <p className="small-text-dark xsmall-text">{description}</p>
      </VerticalLayout>
      </HorizontalLayout>
      {(active) ? icon('off') : icon("on")}
    </div>
  )
}

const SmallToggleStats = ({ title, active, delay, hide }) => {
  const hasDelay = delay > 0
  const delayLabel = hasDelay ? `${delay} ${Number(delay) === 1 ? "dag" : "dagen"}` : "Direct";
  return (
    <div className="vertical center">
      <p className="xsmall-text standard-text-color-light semi-bold">{title}</p>
      {!hide && (icon(active ? 'off' : "on"))}
      {hide && <p className="xsmall-text semi-bold">{delayLabel}</p>}
    </div>
  )
}

const RequirementConditionToggle = ({ value = 1, onChange, disabled }) => {
  return (
    <div className={`req-condition-toggle standard-margin-bottom ${disabled && "disabled"}`}>
      <div className="req-toggle-buttons">
        <button
          className={value === 1 ? "active" : ""}
          onClick={() => onChange(1)}
          type="button"
        >EN
        </button>
        <button
          className={value === 0 ? "active" : ""}
          onClick={() => onChange(0)}
          type="button"
        >
          OF
        </button>
      </div>

      {disabled ?
        <p className="xsmall-text grey-600">
          {disabled && "(Minimaal 2 requirements nodig om te kiezen)"}
        </p>
        :
        <p className="xsmall-text grey-600">
          {value === 1
            ? "*Alle requirements moeten voldoen"
            : "*Minstens één requirement moet voldoen"}
        </p>}
    </div>
  );
};
